export default __webpack_public_path__ + "static/media/company-logo2.e83f981c.png";